export default "__VITE_ASSET__HlFiGMIL__"